import { default as types } from "./types";

const {
  FETCH_RAISE_TYPES_REQUEST,
  FETCH_RAISE_TYPES_SUCCESS,
  FETCH_RAISE_TYPES_FAILURE,
} = types;

const initialState = {
  isLoading: false,
  list: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_RAISE_TYPES_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_RAISE_TYPES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        list: action.payload,
        error: "",
      };
    case FETCH_RAISE_TYPES_FAILURE:
      return {
        ...state,
        isLoading: false,
        list: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
